var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{class:{ 'has-text-danger': _vm.status === 'remove', 'has-text-success': _vm.status === 'add', 'has-text-warning': _vm.status === 'update'}},[_vm._v(_vm._s(_vm.file)+" "),(!_vm.noReset)?_c('button',{staticClass:"button is-small is-text",on:{"click":_vm.reset}},[_vm._v("撤销")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }